var BASE_URL = process.env.CHATBOT_BASE_URL
export default {
    BASE_URL: BASE_URL,
    CHATBOT_DIRECTLINE: 'CHATBOT_DIRECTLINE',
}